//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/Object.js";
import "../no/Preferences.js";
import "../Drawings/Drawings.ViewStyle.js";
let d=[[],[[["feature_type","feature_name","single_line"],"SetSingleLineRepresentation",{},3,0],[["feature_type","feature_name"],"GetSingleLineRepresentation",{R_:{single_line:''}},2,0],[["feature_name","lines_type","color"],"SetColor",{},3,0],[["feature_name","lines_type"],"GetColor",{R_:{color:''}},2,0],[["feature_name","lines_type","font"],"SetFont",{},3,0],[["feature_name","lines_type"],"GetFont",{R_:{font:''}},2,0],[["feature_name","lines_type","width"],"SetWidth",{},3,0],[["feature_name","lines_type"],"GetWidth",{R_:{width:''}},2,0]],[]];
SPLM.Drawings.ShipbuildingLinesViewStyle = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.ShipbuildingLinesViewStyle";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ShipbuildingLinesViewStyle.Lines = Object.freeze({
    "Hidden" : "Hidden", "Visible" : "Visible"});

SPLM.Drawings.ShipbuildingLinesViewStyle.ShipbuildingLines = Object.freeze({
    "Profile" : "Profile", "Plate" : "Plate"});

export default SPLM;